import { WarehouseItemDataDto } from "./WarehouseItemDto";
import { WarehouseItemDataModel } from "./WarehouseItemModel";

export const transformWarehouseItemDtoToModel = (
  dto: WarehouseItemDataDto
): WarehouseItemDataModel => dto;
